
import { defineComponent, onMounted, getCurrentInstance, computed, ref, PropType, watch } from 'vue';
import { AIFeed } from '@/api/ai-feed';
import { AIChatApi } from '@/api/ai-chat';
import { AIAudioCacheService } from './scripts/audio_cache';
import { AIMessage } from '~/store/modules/ai-conversation';

const AIAudioPlayer = defineComponent({
    components: {},
    props: {
        aiFeed: {
            type: Object as PropType<AIFeed> | undefined,
            default: undefined,
        },
        curMessage: {
            type: Object as PropType<AIMessage> | undefined,
            default: undefined,
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const srcLocalUrl = ref('');
        const { generateId, cacheAudioFile, getAudioFileFromCache } = AIAudioCacheService();
        const audioPlayerRef = ref();
        const lastOtherMessage = ref();
        const isMuted = computed<boolean>(() => {
            return proxy?.$store?.state?.aiFeedMoudle?.isMuted;
        });
        const playAudio = () => {
            if (isMuted.value) return;
            proxy.$nextTick(() => {
                console.log('social-ai-audioplayer', 'audio player ref play', audioPlayerRef?.value);
                audioPlayerRef?.value?.play();
            });
        };
        const pauseAudio = () => {
            audioPlayerRef?.value?.pause();
        };
        const synthesisSpeeach = async () => {
            const audioUrl = props?.aiFeed?.bot_first_line_url;

            const id = generateId(props.aiFeed?.bot_id_str, props.curMessage?.messageId);
            console.log('social-ai-audioplayer', 'audio-id', id, props.curMessage);

            cacheAudioFile(audioUrl, id).then(res => {
                console.log('social-ai-audioplayer', 'cacheAudioFile', res);
                getAudioFileFromCache(id)
                    .then(res => {
                        if (res && res instanceof Blob) {
                            const url = URL.createObjectURL(res);
                            srcLocalUrl.value = url;
                            playAudio();
                            console.log('social-ai-audioplayer', 'get audio file', srcLocalUrl);
                        } else {
                            console.log('social-ai-audioplayer', 'did not get audio file');
                        }
                    })
                    .catch(error => {
                        console.log('social-ai-audioplayer', error);
                    });
            });
        };

        const changeMuteStatus = () => {};
        watch(
            () => props.aiFeed,
            newVal => {
                if (!newVal) {
                    console.log('social-ai-audioplayer', 'last message is null or undefined');
                }
                console.log('social-ai-audioplayer', 'last message is changed');
                synthesisSpeeach();
            }
        );
        watch(
            () => isMuted.value,
            newVal => {
                if (newVal) {
                    audioPlayerRef?.value?.pause();
                }
                synthesisSpeeach();
            }
        );
        onMounted(async () => {});

        return { srcLocalUrl, playAudio, pauseAudio, synthesisSpeeach, isMuted, changeMuteStatus, audioPlayerRef };
    },
});
export default AIAudioPlayer;
